import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useUserProfile } from '@backstage/plugin-user-settings';
import { FONT_DISPLAY, TE_SPECTRUM } from '../../theme/themes';
import { HOME_CONTENT_MAX_WIDTH, eyebrowSx } from './HomeCard';
import { AccountMenu } from './AccountMenu';
import {
  auroraBackground,
  greetingForHour,
  greetingNameFor,
} from './viewModel';

// Paper hero band closed by the TotalEnergies spectrum hairline — the same
// brand device the flat page headers use everywhere else in the app.
export const HomeHero = () => {
  const { displayName, loading } = useUserProfile();
  const name = greetingNameFor(displayName);
  const greeting = greetingForHour(new Date().getHours());

  return (
    <Box
      sx={theme => ({
        position: 'relative',
        bgcolor: 'background.paper',
        // "Aurora": the TE spectrum hues as diffuse glows along the top.
        backgroundImage: auroraBackground(theme.palette.mode),
        px: { xs: 2.5, md: 5 },
        py: { xs: 2.75, md: 3.5 },
        borderStyle: 'solid',
        borderWidth: '0 0 3px 0',
        borderImage: `${TE_SPECTRUM} 1`,
      })}
    >
      {/* Pinned to the hero's top right corner, outside the centered frame. */}
      <Box
        sx={{
          position: 'absolute',
          top: { xs: 10, md: 14 },
          right: { xs: 12, md: 20 },
          zIndex: 1,
        }}
      >
        <AccountMenu />
      </Box>
      {/* Same centered frame as the content grid below (wide screens). */}
      <Box sx={{ maxWidth: HOME_CONTENT_MAX_WIDTH, mx: 'auto' }}>
        <Typography component="p" sx={eyebrowSx}>
          TotalEnergies · Agentic Factory
        </Typography>
        <Typography
          component="h1"
          sx={{
            fontFamily: FONT_DISPLAY,
            fontWeight: 750,
            letterSpacing: '-0.01em',
            fontSize: { xs: 25, md: 32 },
            lineHeight: 1.15,
            mt: 1.25,
            mb: 0.5,
          }}
        >
          {greeting}
          {!loading && name ? `, ${name}` : ''}.
        </Typography>
        <Typography sx={{ color: 'text.secondary', fontSize: 14.5 }}>
          Find, create and operate your agentic squads from one place.
        </Typography>
      </Box>
    </Box>
  );
};
